import { ReactNode } from 'react';

import { truncateAddress } from '@/utils/formatter';

interface LeaderMobileCardProps {
  position: number;
  name: string;
  address: string;
  avatar: string;
  borrowPoints: number;
  lendingPoints: number;
  refinancePoints: number;
  totalPoints: number;
  paybackPoints: number;
}

interface LabelProps {
  children: ReactNode;
}

const Label = ({ children }: LabelProps) => {
  return <p className='text-xs font-semibold'>{children}</p>;
};

interface PointsBoxProps {
  title: string;
  points: number;
}

const PointsBox = ({ title, points }: PointsBoxProps) => {
  return (
    <div className='p-5 bg-jet-black'>
      <Label>{title}</Label>
      <p className='text-sm font-space-mono font-normal'>{points}</p>
    </div>
  );
};

function LeaderMobileCard({ position, name, address, avatar, borrowPoints, lendingPoints, paybackPoints, refinancePoints, totalPoints }: LeaderMobileCardProps) {
  return (
    <div className='w-full border-coal-border border'>
      <div className='border-b border-coal-border py-[18px] px-[15px]'>
        <div className='flex items-center gap-[14px]'>
          <p className='text-sm font-space-mono px-3 font-normal'>{position}</p>
          <div className='w-9 h-9 rounded'>
            <img src={avatar} alt='avatar' className='w-full h-full object-cover' />
          </div>
          <div>
            <p className='text-base font-medium leading-normal'>{name}</p>
            <p className='font-space-mono dark:text-coal-50 text-sm font-normal'>{truncateAddress(address)}</p>
          </div>
        </div>
      </div>
      <div className='grid grid-cols-2 gap-[1px] bg-coal-border'>
        <PointsBox title='Borrowing Points' points={borrowPoints} />
        <PointsBox title='Lending Points' points={lendingPoints} />
        <PointsBox title='Payback Points' points={paybackPoints} />
        <PointsBox title='Refinance Points' points={refinancePoints} />
      </div>
      <div className='py-[14px] border-t border-coal-border flex justify-center flex-col items-center'>
        <Label>Total Points</Label>
        <p className='text-base font-space-mono font-bold !text-forest-green'>{totalPoints}</p>
      </div>
    </div>
  );
}

export default LeaderMobileCard;
